// extracted by mini-css-extract-plugin
module.exports = {"container":"PurchaseCard_container__vPwbT","carousel":"PurchaseCard_carousel__pHnaH"};